export default __webpack_public_path__ + "static/javaDev-befb89707df91d042a9d0f706d0773a6.jpg";